<template>
  <div class="payment-success-container">
    <div class="success-card">
      <img
        src="/assets/register_success.png"
        alt="Transaction Processed"
        class="success-icon"
      />
      <h2 class="success-title">Transaction Processed</h2>
      <p class="success-subtitle">Thank you for</p>

      <div class="transaction-details">
        <div class="detail-row">
          <span class="detail-label">Batch ID</span>
          <span class="detail-value">{{ batchId }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Total Transaction</span>
          <span class="detail-value"
            >IDR {{ formatCurrency(totalAmount) }}</span
          >
        </div>
      </div>

      <a
        href="`/transaction/${batchId}`"
        @click.prevent="seeDetails"
        class="see-details-link"
        >See Detail Transaction</a
      >

      <button @click="handleOk" class="ok-button">OK</button>
    </div>
    <div class="footer-text text-center">
      <p>
        &copy; PT Anugrah Multi Remittance {{ new Date().getFullYear() }}
        <span class="footer-separator">|</span>
        <a href="#">Term & Conditions</a>
        <span class="footer-separator">|</span> <a href="#">Privacy Policy</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";

const router = useRouter();
const route = useRoute();

const store = useStore();

store.state.hideConfigButton = false;
store.state.showTransferNavbar = true;
store.state.showNavbar = false;
store.state.showSidenav = false;
store.state.showFooter = false;

const batchId = ref(null);
const totalAmount = ref(0);

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "0";
  return Number(value).toLocaleString("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

onMounted(() => {
  const state = history.state;
  if (state) {
    batchId.value = state.batchId || "N/A";
    totalAmount.value = state.totalAmount || 0;
  }
  // Fallback if accessed directly without state (though less likely for this page)
  if (!batchId.value && route.query.batchId)
    batchId.value = route.query.batchId;
  if (totalAmount.value === 0 && route.query.totalAmount)
    totalAmount.value = parseFloat(route.query.totalAmount);
});

const seeDetails = () => {
  // Assuming you have a route for transaction details that takes batchId
  if (batchId.value && batchId.value !== "N/A") {
    router.push({ name: "TransactionDetail", params: { id: batchId.value } });
  } else {
    // Handle case where batchId is not available
    router.push({ name: "TransactionHistory" });
  }
};

const handleOk = () => {
  router.push({ name: "Transfer" });
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");

.payment-success-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f0fdf4; /* Light green background from image */
  padding: 20px;
  font-family: "Inter", sans-serif;
}

.success-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  padding: 40px;
  text-align: center;
  width: 100%;
  max-width: 480px; /* Adjust as needed */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.success-icon {
  width: 100px; /* Adjust size as per the image */
  height: 100px;
  margin-bottom: 24px;
}

.success-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 8px;
}

.success-subtitle {
  font-size: 16px;
  color: #718096; /* Grey text */
  margin-bottom: 32px;
}

.transaction-details {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  font-size: 16px;
}

.detail-row:not(:last-child) {
  border-bottom: 1px solid #e2e8f0;
}

.detail-label {
  color: #4a5568; /* Medium grey */
}

.detail-value {
  color: #1a202c; /* Dark text */
  font-weight: 600;
}

.see-details-link {
  font-size: 16px;
  color: #3182ce; /* Blue link */
  text-decoration: none;
  margin-bottom: 32px;
  font-weight: 500;
}

.see-details-link:hover {
  text-decoration: underline;
}

.ok-button {
  background-color: #48bb78; /* Green button */
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  height: 48px;
  transition: background-color 0.2s;
}

.ok-button:hover {
  background-color: #38a169; /* Darker green */
}

.footer-text {
  font-size: 12px;
  color: #a0aec0; /* Lighter grey for footer */
  padding-top: 40px;
  padding-bottom: 20px;
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.footer-text a {
  color: #a0aec0;
  text-decoration: none;
}

.footer-text a:hover {
  text-decoration: underline;
  color: #718096;
}

.footer-separator {
  margin: 0 5px;
}

/* Ensure the container allows absolute positioning of footer */
.payment-success-container {
  position: relative;
  padding-bottom: 80px; /* Space for the absolute footer */
}
</style>
